//@ts-nocheck
import { Select, ConfigProvider } from 'antd';
import React, { forwardRef } from 'react';
import Label from './Label';
import HelperText from './HelperText';
import cn from 'classnames';

type Props = {
  id?: string;
  name?: string;
  status?: 'error' | 'success';
  disabled?: boolean;
  helperText?: string;
  label?: string;
  required?: boolean;
  options?: { value: string | number; label: string }[];
  defaultValue?: string;
  mode?: 'multiple' | 'tags';
  labelHelperText?: string;
  labelClassName?: string;
} & Omit<React.ComponentProps<typeof Select>, 'status'>;

const InputSelect = forwardRef<HTMLInputElement, Props>(
  (
    {
      options,
      defaultValue,
      label,
      id,
      disabled,
      status,
      required,
      helperText,
      mode,
      labelHelperText,
      labelClassName,
      className,
      value,

      ...reset
    }: Props,
    ref
  ) => {
    return (
      <div
        className={cn('w-full custom-select flex flex-col', {
          disabled: disabled,
        })}
      >
        {label && (
          <Label
            labelHelperText={labelHelperText}
            text={label}
            required={required}
            htmlFor={id}
            className={labelClassName}
          />
        )}
        <ConfigProvider
          theme={{
            components: {
              Select: {
                hoverBorderColor: 'oklch(74% 0.238 322.16)',
                colorPrimary: 'oklch(74% 0.238 322.16)',
              },
            },
          }}
        >
          <Select
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            mode={mode}
            size="large"
            status={status}
            disabled={disabled}
            className={cn(
              'w-full flex items-center text-start [&_.ant-select-selector]:!rounded-xl',
              {
                'status-error': status === 'error',
                'status-success': status === 'success',
                '[&_.ant-select-selector]:!border-red-500': status === 'error',
                '[&_.ant-select-selector]:!border-green-500': status === 'success',
              },
              className
            )}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            defaultValue={defaultValue}
            id={id}
            options={options}
            value={value || undefined}
            {...reset}
            ref={ref}
          />
        </ConfigProvider>
        {helperText && (
          <HelperText className="mt-2 block" text={helperText} disabled={disabled} status={status} />
        )}
      </div>
    );
  }
);

InputSelect.displayName = 'InputSelect';

export default InputSelect;
